import React from 'react';
import { useRevealAnimation } from '@/hooks/useRevealAnimation';

export const Paragraph: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { ref, isVisible } = useRevealAnimation();

  return (
    <p
      ref={ref}
      className={`text-lg leading-relaxed mb-4 dark:text-zinc-300 transform transition-all duration-700 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
      }`}
    >
      {children}
    </p>
  );
};
